import { Skeleton } from "@mui/material";
import FragmentFullContent from "./FragmentFullContent";

const ElementSkeleton = () => {
    return <FragmentFullContent>
      <Skeleton width="100%" />
      <Skeleton width="100%" animation="wave" />
      <Skeleton width="100%" animation={false} />
    </FragmentFullContent>;
};

export default ElementSkeleton;